'use client';

import { Activity, AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

type PriceActivityEmptyProps = {
  categoryLabel: string;
};

export function PriceActivityEmpty({ categoryLabel }: PriceActivityEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-4 py-14 text-center">
      <span
        className={cn(
          'inline-flex h-14 w-14 items-center justify-center rounded-2xl',
          'border border-sky-400/25 bg-sky-500/10',
          'shadow-[0_0_24px_rgba(56,189,248,0.12)]'
        )}
      >
        <Activity className="h-6 w-6 text-sky-300/80" aria-hidden />
      </span>
      <div className="space-y-1.5">
        <p className="font-poppins text-sm font-semibold text-sky-50">
          Nenhuma alteração recente
        </p>
        <p className="max-w-sm font-inter text-sm leading-relaxed text-sky-200/55">
          Ainda não detectámos mudanças de preço em powers de {categoryLabel}.
        </p>
      </div>
    </div>
  );
}

export function PriceActivityError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-4 py-14 text-center">
      <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-rose-400/25 bg-rose-500/10">
        <AlertCircle className="h-6 w-6 text-rose-300" aria-hidden />
      </span>
      <div className="space-y-1.5">
        <p className="font-poppins text-sm font-semibold text-sky-50">
          Não foi possível carregar
        </p>
        <p className="max-w-sm font-inter text-sm text-sky-200/55">
          Tente novamente em instantes.
        </p>
      </div>
      <button
        type="button"
        onClick={onRetry}
        className={cn(
          'mt-1 rounded-xl border border-sky-400/35 bg-sky-500/15 px-4 py-2',
          'font-poppins text-xs font-semibold text-sky-100',
          'transition-colors hover:border-sky-300/50 hover:bg-sky-400/20',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/50'
        )}
      >
        Tentar novamente
      </button>
    </div>
  );
}
